/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../components/Header/index';
import Sidebar from '../components/Sidebar/index';
import ChatbotAgent from '../components/ChatbotAgent';
import { ROLES, resolveUserRole } from '../constants/rolePermissions';

const DefaultLayout = ({ children }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    // Read from localStorage on initial load
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });
  const { user } = useSelector(state => state);
  const userRole = resolveUserRole(user?.role, user?.roleName, user?.userRole);
  const shouldShowSetupProgress = userRole !== ROLES.DEMO_USER;

  // Save to localStorage whenever collapse state changes
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', sidebarCollapsed);
  }, [sidebarCollapsed]);

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">
        {/* <!-- ===== Sidebar Start ===== --> */}
        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          isCollapsed={sidebarCollapsed}
          setIsCollapsed={setSidebarCollapsed}
        />
        {/* <!-- ===== Sidebar End ===== --> */}

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden transition-all duration-300">
          <div className="sticky top-0 z-[1000]">
            {/* <!-- ===== Header Start ===== --> */}
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              showSetupProgress={shouldShowSetupProgress}
            />
            {/* <!-- ===== Header End ===== --> */}
          </div>

          {/* <!-- ===== Main Content Start ===== --> */}
          <main>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
              {children}
            </div>
          </main>
          {/* <!-- ===== Main Content End ===== --> */}
          {location.pathname !== '/ai-assistant' && <ChatbotAgent />}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
    </div>
  );
};

export default DefaultLayout;
